<template>
  <div class="notification is-info">
  <button class="delete" @click="closeMessage"></button>
    <p>{{$store.state.notificationText}}</p>
</div>
</template>

<script>
export default {
  methods: {
    closeMessage(){
      this.$store.dispatch('closeMessage');
    }
  }
}
</script>

<style>
</style>
